import {Button, Icon} from "~/components";
import {Tooltip} from "antd";
import {useState} from "react";

function RequestDemoAction({item, setItemEdit, openModal, can, handleStatus})
{
	const buttonHandlers = {
		edit: () => {
			setItemEdit(item);
			openModal('edit');
		},
		delete: () => {
			setItemEdit(item);
			openModal('delete');
		},
	};

	const actionButtons = [
		can.edit && <Button key="edit" background blue leftIcon={Icon.edit} onClick={buttonHandlers.edit}></Button>,
		can.delete && <Button key="delete" background red leftIcon={Icon.delete} onClick={buttonHandlers.delete}></Button>,
		<Tooltip title="Thông tin"><Button background blue leftIcon={Icon.info} to={`/request-demo/detail/${item.id}`}></Button></Tooltip>
	];

	return (
		<div className="table-action d-flex">
			{actionButtons}
		</div>
	)
}

export default RequestDemoAction;